module.exports = __webpack_public_path__ + "0bd371c8ffdd4d14e3db40ebea8b7d23.png";